"use client";
import React, { ReactElement } from "react";
import ScrollToTop from "src/app/components/ScrollTop";
import { Template } from "src/types";
import { ScrollToTop2, ScrollToTop3 } from "src/app/components/ScrollTop";
import { useTheme } from "../../contexts/useTheme";

// Component map
const scrollComponentMap: {
  [key in Template]?: React.ElementType; // Use ElementType to allow for any component type
} = {
  design1: ScrollToTop,
  design2: ScrollToTop2,
  design3: ScrollToTop3,
};

// Selector function
export function GetScrollToTopComponent(): ReactElement {
  const { config } = useTheme();
  const SelectedComponent =
    scrollComponentMap[config?.template as Template] || ScrollToTop;
  return <SelectedComponent />; // Return the selected component
}
